export class RoomAlreadyExistsMessage {
    public code: string;
    
    constructor(code: string)
    {
        this.code = code;
    }
}